import React, { useState } from 'react';
import { resetPasswordSchema } from '../../../utils/schema';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import useAppNavigate from '../../hooks/useAppNavigate';
import { setPassword } from '../../../redux/features/coach/actions/authAction';
import Eye from '../../form/Eye';
import ErrorMessage from '../../form/ErrorMessage';
import { Formik } from 'formik';

const ResetPassword = ({ onClose, forgot_code, backToLogin }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { goTo } = useAppNavigate();
    const [isEye1, setIsEye1] = useState(false);
    const [isEye2, setIsEye2] = useState(false);
    // const forgot_code = location?.state?.data.code || "";
    const initialValues = {
        newPassword: "",
        confirm_password: "",
    };

    const handleChangePassword = (values) => {
        const callback = (response) => {
            if (response.success) {
                onClose();
            };
        };
        const data = {
            newPassword: values?.newPassword,
            forgot_code,
        };
        dispatch(setPassword({ payload: data, callback }));
    };

    return (
        <div
            className="modal d-block ct_large_modal_width ct_congratulation_modal_fade"
            tabIndex="-1"
        >
            <div class="modal-dialog modal-dialog-centered ct_modal-dialog">
                <div class="modal-content">
                    <div class="modal-header border-0 p-0 pb-2">
                        <button
                            type="button"
                            class="btn-close ct_close_position_right12"
                            onClick={onClose}
                        ></button>
                    </div>
                    <div class="modal-body pe-0">
                        <section class="ct_signup_main py-3">
                            <div class="container-fluid">
                                <div class="row align-items-center">
                                    <div class="col-xxl-4 col-xl-4 col-lg-4 mb-4 mb-lg-0 d-none d-lg-block">
                                        <div class="ct_signup_left_img">
                                            <img src="/assets/img/login_coach.png" alt="" />
                                        </div>
                                    </div>
                                    <div class="col-xxl-8 col-xl-7 col-lg-7 mb-4 mb-lg-0 mx-auto pe-0">
                                        <div class="ct_signup_right_content px-3 ct_custom_scroll pe-5">
                                            <div class="ct_signup_logo ct_mb_30">
                                                <img src="/assets/img/Nuvio_logo.png" alt="" />
                                            </div>
                                            <div class="mt-0 text-center">
                                                <h2 class="ct_fs_32  mb-2 ct_darkblue_text">Set New Password</h2>
                                                <p class="mb-0 ct_darkblue_text">
                                                    Enter your new password below. Make sure it’s strong and unique to
                                                    keep your account secure.
                                                </p>
                                            </div>
                                            <Formik
                                                initialValues={initialValues}
                                                validationSchema={resetPasswordSchema}
                                                onSubmit={(values, actions) => {
                                                    handleChangePassword(values);
                                                }}
                                            >
                                                {({
                                                    values,
                                                    errors,
                                                    touched,
                                                    handleChange,
                                                    handleBlur,
                                                    handleSubmit,
                                                    setFieldValue,
                                                }) => (
                                                    <form action="" class="mt-5">
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <div class="form-group mb-3">
                                                                    <label for="" class="mb-2 d-block ct_darkblue_text">
                                                                        Password
                                                                    </label>
                                                                    <div class="position-relative">
                                                                        <input
                                                                            class="form-control ct_input pe-5"
                                                                            placeholder="Password"
                                                                            type={isEye1 ? "text" : "password"}
                                                                            id="newPassword"
                                                                            value={values.newPassword}
                                                                            onBlur={handleBlur}
                                                                            onChange={handleChange}
                                                                        />
                                                                        <Eye
                                                                            isEye={isEye1}
                                                                            onClick={() => setIsEye1(!isEye1)}
                                                                        />
                                                                        {/* <i class="fa-solid fa-eye ct_show_eye"></i> */}
                                                                    </div>
                                                                    <ErrorMessage
                                                                        errors={errors}
                                                                        touched={touched}
                                                                        fieldName="newPassword"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <div class="form-group mb-3">
                                                                    <label for="" class="mb-2 d-block ct_darkblue_text">
                                                                        Confirm Password
                                                                    </label>
                                                                    <div class="position-relative">
                                                                        <input
                                                                            class="form-control ct_input pe-5"
                                                                            placeholder="Confirm password"
                                                                            type={isEye2 ? "text" : "password"}
                                                                            id="confirm_password"
                                                                            value={values?.confirm_password}
                                                                            onBlur={handleBlur}
                                                                            onChange={handleChange}
                                                                        />
                                                                        <Eye
                                                                            isEye={isEye2}
                                                                            onClick={() => setIsEye2(!isEye2)}
                                                                        />
                                                                    </div>
                                                                    <ErrorMessage
                                                                        errors={errors}
                                                                        touched={touched}
                                                                        fieldName="confirm_password"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="text-center mt-2">
                                                            <a
                                                                onClick={(e) => {
                                                                    handleSubmit(e);
                                                                }}
                                                                class="ct_yellow_btn w-75 mx-auto"
                                                            >
                                                                Reset Password{" "}
                                                            </a>
                                                        </div>
                                                    </form>
                                                )}
                                            </Formik>
                                            <div class="ct_back_login_text text-center mt-3">
                                                <a
                                                    onClick={backToLogin}
                                                    class="mb-0 ct_darkblue_text"
                                                >
                                                    <i class="fa-solid fa-arrow-left"></i> Back to Log In
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>

        </div>
    )
};

export default ResetPassword;